import React from 'react';
import { createRoot } from 'react-dom/client';
import WorkCatalog from './components/WorkCatalog';

const container = document.getElementById('work-catalog-root');

if (container) {
  const limitAttr = container.getAttribute('data-limit');
  const parsedLimit = Number.parseInt(limitAttr || '', 10);
  const limit = Number.isFinite(parsedLimit) ? parsedLimit : undefined;

  const root = createRoot(container);
  root.render(<WorkCatalog limit={limit} />);
}
